/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PostPutCreateBudgetInput = {
    budget_name: string;
    facility_id: string;
    budget_type: PostPutCreateBudgetInput.budget_type;
    currency: string;
    start_date: string;
    end_date: string;
    commodities_in_budget: Array<string>;
    sales_included: boolean;
    production_included: boolean;
    production_units: Array<string>;
    budget_map: Array<{
        dates_column: string;
        budget_data: {
            commodity_ids: Array<{
                id: string;
                name: string;
                cost: number;
                usage: number;
                usage_uom: Record<string, any>;
            }>;
            production_units_ids: Array<{
                id: string;
                name: string;
                value: number;
            }>;
            sales: Array<{
                id: string;
                cost: number;
            }>;
        };
    }>;
};

export namespace PostPutCreateBudgetInput {
    export enum budget_type {
        ANNUALLY = 'Annually',
        QUARTERLY = 'Quarterly',
        MONTHLY = 'Monthly',
    }
}
